(function () {
  'use strict';

  // Close any open <details> dropdowns when clicking outside or pressing Escape
  function closeDetails(except) {
    document.querySelectorAll('details[data-dropdown][open], details[data-search][open], details[data-menu-drawer][open]').forEach(function (d) {
      if (d !== except && !d.contains(except)) d.removeAttribute('open');
    });
  }
  document.addEventListener('click', function (e) {
    var inside = e.target.closest('details[data-dropdown], details[data-search], details[data-menu-drawer]');
    closeDetails(inside);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('details[data-dropdown][open], details[data-search][open], details[data-menu-drawer][open]');
      if (open) { open.removeAttribute('open'); var s = open.querySelector('summary'); if (s) s.focus(); }
    }
  });

  // Focus the search input when the search popover opens
  document.querySelectorAll('details[data-search]').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) { var i = d.querySelector('input[type="search"]'); if (i) i.focus(); } });
  });

  // Mobile drawer: position below header, lock scroll
  var header = document.querySelector('[data-header]');
  function setHeaderBottom() {
    if (!header) return;
    document.documentElement.style.setProperty('--header-bottom', Math.max(header.getBoundingClientRect().bottom, 0) + 'px');
  }
  document.querySelectorAll('details[data-menu-drawer]').forEach(function (d) {
    d.addEventListener('toggle', function () {
      setHeaderBottom();
      document.body.style.overflow = d.open ? 'hidden' : '';
    });
  });
  window.addEventListener('resize', setHeaderBottom);

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var next = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-change'), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Collection sort
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.product__main-image');
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.getAttribute('data-src');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.alt = thumb.getAttribute('data-alt') || '';
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  // Variant picker
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addLabel = root.querySelector('[data-add-to-cart-label]');
    var gallery = document.querySelector('[data-gallery]');
    var main = gallery ? gallery.querySelector('.product__main-image') : null;
    var formatter;
    try { formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: root.getAttribute('data-currency') || 'USD' }); } catch (err) { formatter = null; }
    function money(cents) { return formatter ? formatter.format(cents / 100) : (cents / 100).toFixed(2); }

    function update() {
      var selected = Array.prototype.map.call(root.querySelectorAll('[data-option-group]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      var variant = product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = root.getAttribute('data-unavailable-text');
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? root.getAttribute('data-add-text') : root.getAttribute('data-soldout-text');
      if (variant.featured_image && main) {
        main.src = variant.featured_image.src;
        main.removeAttribute('srcset');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-group]')) update(); });
  });
})();
